module.exports = __webpack_public_path__ + "static/image/history/pc/201911@3x.ver2_0_2.jpg?e623c3b9";